export default __webpack_public_path__ + "static/media/paper.434f5835.png";